var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5543 4.69368C12.3499 4.19956 11.65 4.19956 11.4455 4.69368L9.83155 8.59411C9.70036 8.91117 9.4003 9.12604 9.05788 9.14813L4.93266 9.41427C4.39861 9.44873 4.17344 10.1122 4.57619 10.4646L7.84259 13.3227C8.09468 13.5433 8.20341 13.8856 8.12481 14.2112L7.19505 18.063C7.07133 18.5756 7.62143 18.987 8.07813 18.7235L11.5502 16.7204C11.8285 16.5599 12.1714 16.5599 12.4497 16.7204L15.9217 18.7235C16.3785 18.987 16.9285 18.5756 16.8048 18.063L15.8751 14.2112C15.7965 13.8856 15.9052 13.5433 16.1573 13.3227L19.4237 10.4646C19.8264 10.1122 19.6013 9.44873 19.0672 9.41427L14.942 9.14813C14.5996 9.12604 14.2995 8.91117 14.1683 8.59411L12.5543 4.69368ZM9.7823 4.00544C10.6002 2.02897 13.3997 2.02897 14.2176 4.00544L15.6172 7.38795L19.1831 7.61801C21.3193 7.75583 22.22 10.4096 20.609 11.8192L17.7527 14.3185L18.5546 17.6407C19.0494 19.6909 16.8491 21.3366 15.0222 20.2827L11.9999 18.539L8.97763 20.2827C7.1508 21.3366 4.95043 19.6909 5.4453 17.6407L6.24721 14.3185L3.39088 11.8192C1.77988 10.4096 2.68056 7.75583 4.81677 7.61801L8.38264 7.38795L9.7823 4.00544Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOutline);
export default __webpack_public_path__ + "static/media/favorite_outline.ab29b2526056e02917ab7893a0a647c4.svg";
export { ForwardRef as ReactComponent };